import apiClient from '../base/apiClient';

export const configApi = {
  getConfigurations: async (resource: string) => {
    const response = await apiClient.get('/Administration/Configuration/ListAll');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    if (!response.data.configurations || !Array.isArray(response.data.configurations)) {
      throw new Error('No valid configurations found in the response');
    }
    const configurations: Config[] = response.data.configurations;
    const idTracker: { [key: string]: number } = {};
    const groupedConfigs = configurations.reduce((acc: GroupedConfigs, config: Config) => {
      const groupName = config.group || 'General';
      let baseId = config.name.toLowerCase().replace(/ /g, '_');
      let uniqueId = baseId;
      if (idTracker[baseId]) {
        uniqueId = `${baseId}_${idTracker[baseId]}`;
        idTracker[baseId]++;
      } else {
        idTracker[baseId] = 1;
      }
      if (!acc[groupName]) acc[groupName] = { name: groupName, items: [] };
      acc[groupName].items.push({
        id: uniqueId,
        name: config.display,
        apiName: config.name,
        description: config.description || '',
        value: config.value || '',
        dataType: config.dataType,
        group: config.group || '',
        type: config.type,
      });
      return acc;
    }, {} as GroupedConfigs);
    return { data: Object.values(groupedConfigs) };
  },

  getConfigurationValue: async (params: { name: string }) => {
    const { name } = params;
    const response = await apiClient.get(`/Administration/Configuration/Get?name=${encodeURIComponent(name)}`);
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    if (response.data.value === null || response.data.value === undefined) {
      throw new Error(`No valid value found for configuration: ${name}`);
    }
    return { data: { value: response.data.value } };
  },

  updateConfigurationValue: async (params: { name: string; value: string }) => {
    const { name, value } = params;
    const response = await apiClient.post('/Administration/Configuration/Set', { name, value }, {
      headers: { 'Content-Type': 'application/json' },
    });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { name, value } };
  },
};